import { Box, Divider, Skeleton } from '@mui/material';

/**
 * Skeleton for a single Live Topics list item: caption + optional chip row, then title (max 2 lines).
 * Matches LiveTopicsPanelItem layout (metadata row + title).
 */
export function LiveTopicsPanelItemSkeleton() {
  return (
    <>
      <Box sx={{ p: 1.25 }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 1,
            mb: 0.5,
          }}
        >
          <Skeleton variant="text" width={80} height={18} />
          <Skeleton variant="rounded" width={64} height={22} sx={{ borderRadius: 2 }} />
        </Box>
        <Skeleton variant="text" width="95%" height={22} />
        <Skeleton variant="text" width="70%" height={22} />
      </Box>
      <Divider />
    </>
  );
}
